import type { Podcast as PodcastType } from '@ps/web-martech-cms-types';
import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';

import { CMSHTML, CMSHeading } from '@swf/cms';
import Translation from '@swf/components/Translation/Translation';
import { fetchJson } from '@swf/core/utils/api';

import {
  TXTINT_FORMAT_LongTime,
  TXTINT_FORMAT_LongTimeMin,
  TXTWCL_Show_more
} from './CMSPodcast.messages.json';
import styles from './CMSPodcast.scss';
import PlayButtonIcon from './assets/play.svg';

interface PodcastItem {
  title: string;
  subtitle: string;
  guid: string;
  pubDate: string;
  summary: string;
  duration: string;
}

interface Podcast {
  items: PodcastItem[];
}

const CMSPodcast: React.FC<PodcastType> = ({ url }) => {
  const [podcast, setPodcast] = useState<Podcast>();
  const [podcastLimit, setPodcastLimit] = useState(5);
  const { formatMessage } = useIntl();

  useEffect(() => {
    const abortController = new AbortController();
    const { signal } = abortController;

    const load = async () => {
      try {
        const podcastData = await fetchJson(url, { mode: 'cors', signal });
        setPodcast({ items: podcastData.rss.channel.item });
      } catch {
        setPodcast(undefined);
      }
    };

    load();

    return () => abortController.abort();
  }, [url]);

  const getTime = (timeStamp: string) => {
    const times = timeStamp.split(':');
    if (times.length === 3) {
      return formatMessage(TXTINT_FORMAT_LongTime, {
        0: times[0].replace(/^0/, ''),
        1: times[1].replace(/^0/, '')
      });
    } else {
      return formatMessage(TXTINT_FORMAT_LongTimeMin, { 0: times[0].replace(/^0/, '') });
    }
  };

  return (
    <div className={styles.container}>
      {podcast?.items.slice(0, podcastLimit).map((item, index) => (
        <article className={styles.podcast} key={index}>
          <CMSHeading
            target="_blank"
            level="h3"
            size="s"
            url={item.guid}
            hero={false}
            alignment={null}
            title={item.title}
            className={styles.title}
          />
          <CMSHeading
            target="_blank"
            level="h4"
            size="xs"
            hero={false}
            alignment={null}
            title={item.subtitle}
          />
          <CMSHTML content={item.summary} />
          <div className={styles.playContainer}>
            <a href={item.guid} className={styles.playBtn} target="_blank" rel="noreferrer">
              <PlayButtonIcon className={styles.playBtnIcon} />
            </a>{' '}
            <span className={styles.duration}>{getTime(item.duration)}</span>
          </div>
        </article>
      ))}
      {podcastLimit < (podcast?.items?.length || 0) && (
        <button onClick={() => setPodcastLimit((value) => value + 10)} className={styles.showMore}>
          <Translation {...TXTWCL_Show_more} />
        </button>
      )}
    </div>
  );
};
export default CMSPodcast;
